import Api from '..';
import { SmtpConfiguration } from 'src/models/smtpConfiguration';
import { PaginatedState } from 'src/models/paginatedState';
export class SmtpConfigurationService {
  static async createSmtpConfig(
    smtp: SmtpConfiguration
  ): Promise<{ success: boolean; message: string; data?: object }> {
    try {
      const response = await Api.client.post('store-smtp-details', smtp);
      return {
        success: true,
        message:
          response.data?.message || 'SMTP configuration created successfully.',
        data: response.data?.data || {}
      };
    } catch (e: any) {
      if (e.response) {
        const status = e.response.status;
        const message = e.response.data?.message || 'Unknown error';

        if (status === 400 || status === 422) {
          return {
            success: false,
            message: message
          };
        } else {
          return {
            success: false,
            message: `Server error: ${message}`
          };
        }
      } else {
        // Network or unknown error
        return {
          success: false,
          message: 'Please enter a valid SMTP details, no response from server.'
        };
      }
    }
  }

  static async getSmtpConfigs(
    { name = '' },
    paginatedState: PaginatedState = { per_page: 5, page: 0 }
  ): Promise<SmtpConfiguration[]> {
    var params = {
      name
    };

    const queryString = Object.entries(paginatedState)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join('&');

    const baseUrl = 'get-all-smtp-details';
    const urlWithQuery = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    try {
      const response = await Api.client.get(urlWithQuery, { params });
      return response.data.data;
    } catch (e) {
      throw e;
    }
  }

  static async getSmtpConfigsAll(): Promise<SmtpConfiguration[]> {
    const baseUrl = 'get-all-smtp';

    try {
      const response = await Api.client.get(baseUrl);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  }

  static async deleteSmtpConfig(
    id: number
  ): Promise<{ success: boolean; message: string }> {
    try {
      const response = await Api.client.delete(`smtp/${id}`);
      return response.data; // Return full response
    } catch (e) {
      console.log(e.response);
      throw e;
    }
  }

  static async updateSmtpConfig(
    smtp: SmtpConfiguration
  ): Promise<{ success: boolean; message: string; data: number | null }> {
    console.log(smtp, 'SMTP Config to update'); // Log the SMTP config being updated
    try {
      const response = await Api.client.post(
        `update-smtp-details/${smtp.id}`,
        smtp
      );
      return {
        success: true,
        message: response.data?.message || 'SMTP config updated successfully.',
        data: response.data?.data || 0
      };
    } catch (e: any) {
      console.log('Error:', e); // Log the full error object
      console.log('Error Response:', e.response); // Log the response if available

      // If there's a response, we handle the error based on status codes
      if (e.response) {
        const { status, data } = e.response;
        const message = data?.message || 'Unknown error';

        if (status === 400 || status === 422) {
          // Handle client errors (bad request or validation errors)
          return {
            success: false,
            message: message,
            data: null
          };
        } else {
          // Handle server errors (500, 503, etc.)
          return {
            success: false,
            message: `Server error: ${message}`,
            data: null
          };
        }
      } else {
        // Network or unknown errors (e.g., no response from server)
        return {
          success: false,
          message:
            'Please enter a valid SMTP details, no response from server.',
          data: null
        };
      }
    }
  }

  static async verifySmtpConfig(
    smtp: SmtpConfiguration
  ): Promise<{ success: boolean; message: string; data?: object }> {
    try {
      const response = await Api.client.post('send-verify-email', smtp);
      return {
        success: true,
        message:
          response.data?.message || 'SMTP configuration created successfully.',
        data: response.data?.data || {}
      };
    } catch (e: any) {
      if (e.response) {
        const status = e.response.status;
        const message = e.response.data?.message || 'Unknown error';

        if (status === 400 || status === 422) {
          return {
            success: false,
            message: message
          };
        } else {
          return {
            success: false,
            message: `Server error: ${message}`
          };
        }
      } else {
        // Network or unknown error
        return {
          success: false,
          message: 'Please enter a valid SMTP details, no response from server.'
        };
      }
    }
  }
}
